module.exports = __webpack_public_path__ + "e455ccf6080ff0f5476b2caa8f4a1063.jpg";